import dayjs, { type Dayjs } from "dayjs";
import * as React from "react";

import { cn } from "../../lib/cn";
import { Input } from "../../primitive/input";

export interface DateInputProps extends Omit<
  React.ComponentProps<typeof Input>,
  "type" | "value" | "onChange"
> {
  value: Dayjs | null | undefined;
  onChange: (value: Dayjs) => void;
}

function DateInput({ className, value, onChange, ...props }: DateInputProps) {
  return (
    <Input
      type="date"
      value={value?.format("YYYY-MM-DD") ?? ""}
      onChange={(event) => {
        const nextValue = dayjs(event.target.value, "YYYY-MM-DD", true);

        if (nextValue.isValid()) {
          onChange(nextValue.startOf("day"));
        }
      }}
      className={cn("h-8 w-36", className)}
      {...props}
    />
  );
}

export { DateInput };
